export default __webpack_public_path__ + "89f55bc79f710b771f4974d0f87f868a.png";